<template>
  <div class="remainder-alert haircut">
    <div class="container">
      <h1 class="head">Reminder Alert !</h1>

      <div class="col-md-10">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submit)">
            <div class="form">
              <ValidationProvider
                name="Contact Number"
                :rules="{
                  regex:
                    /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[4])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/,
                  required: true,
                }"
                v-slot="{ errors }"
              >
                <div class="form-group mobile-number py-3">
                  <label for="Contact No">Contact Number</label>
                  <input
                    class="form-control"
                    v-model="contact_number"
                    type="number"
                    placeholder="Contact Number"
                  />
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>

              <div class="py-2 text-white text-center note">
                *Note: Reminder will be sent to the provided phone number
              </div>
              <div class="buttons pt-5 d-flex justify-content-between">
                <router-link class="text-decoration-none" to="/"
                  ><button class="btn cancel-btn">Cancel</button></router-link
                >

                <button
                  class="btn submit-btn"
                  type="submit"
                  :disabled="btn_disabled"
                >
                  Continue
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
    <v-dialog />
    <div style="display: none">
      <img id="print_logo" src="https://api.butosi.com/static/logo.png" />
      <canvas id="canvas" width="900" height="400"></canvas>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "Remainder",
  data() {
    return {
      btn_disabled: false,
      name: "",
      contact_number: "",
      token_number: "",
      service: {},
    };
  },
  mounted() {
    this.isLoading(true);
    this.getSingleServiceDetail();
  },
  methods: {
    submit() {
      this.isLoading(true);
      this.btn_disabled = true;
      const formData = new FormData();
      formData.append("contact_number", this.contact_number);
      formData.append("service_id", this.service.id);
      this.$http
        .post("token/generate", formData)
        .then((res) => {
          this.isLoading(false);
          if (res.data.status == 1) {
            this.token_number = res.data.data.token_number;
            this.$router.push({
              name: "TokenPage",
              params: {
                token: this.token_number,
              },
            });
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
            this.btn_disabled = false;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading(false);
        });
    },
    getSingleServiceDetail() {
      this.$http.get(`/service/${this.$route.params.slug}`).then((res) => {
        if (res.data.status == 1) {
          this.service = res.data;
          this.isLoading(false);
        } else {
          this.$notify({
            group: "notifications",
            title: res.data.message,
            type: "error",
            text: res.data.errors[0],
          });
          this.isLoading(false);
        }
      });
    },
    ...mapMutations({
      isLoading: "loading",
    }),
  },
};
</script>

<style>
.vue-dialog {
  font-size: 26px !important;
  width: 40% !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  height: auto !important;
  border-radius: 10px !important;
}
.vm--modal {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #695f5f !important;
  color: #e8eaea !important;
  /* color: #555!important; */

  border-radius: 3px;
  padding: 20px !important;
  box-shadow: 0 20px 60px -2px rgb(27 33 58 / 40%);
}
.vue-dialog .vue-dialog-content {
  flex: 1 0 auto;
  width: 100%;
  padding: 14px;
  text-align: center;
  border-bottom: 1px solid #9d9d9d;
}

.vue-dialog-buttons {
  display: flex;
  flex: 0 1 auto;
  width: 100%;
  border-top: none !important;
  padding-top: 10px !important;
}
</style>
